import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'
import api from '../../../api'

import RailsError from '../../util/RailsError'

@inject('users')
@observer
export default class UserDelete extends Component {

  state = {
    errors: null,
  }

  get user() {
    return this._user || (this._user = this.props.users.findById(this.props.params.user_id))
  }

  getUsers() {
    return this.props.users.filter(user => {
      return user.admin && user.id !== this.user.id
    })
  }
 
  deleteUser = event => {
    event.preventDefault()

    const confirmed = window.confirm('This cannot be undone. Click OK to really delete.')
    if (!confirmed) {
      return
    }

    const reassign_to = event.target.elements.namedItem("reassign_to").value
    api.delete(`users/${this.user.id}`, { params: { reassign_to }}).then(() => {
      this.props.users.load()
      this.props.router.replace('/users')
    }).catch(({ response }) => this.setState({ errors: response.data && response.data.errors }))
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.user_id !== this.props.params.user_id) {
      this._user = null
      this.forceUpdate()
    }
  }

  render() {
    if (!this.user) {
      return <div className="loading">Loading...</div>
    }

    const { errors } = this.state
    return (
      <form onSubmit={this.deleteUser}>
        <div className="panel padded">
          <h2 className="title">Delete User {this.user.name}</h2>

          {errors && <RailsError errors={errors} />}

          <div className="form-section">
            <label htmlFor="reassign_to">Reassign {this.user.name}'s Leads, Hotsheets, Searches, Recommendations, etc. to:</label>
            <select name="reassign_to" id="reassign_to">
              {this.getUsers().map(user => (
                <option key={user.id} value={user.id}>{user.name}</option>
              ))}
            </select>
          </div>

        </div>
        <button type="submit" className="danger big shadowed">Delete User</button>
        <div style={{textAlign: 'center'}}><Link to="/users">Cancel</Link></div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/users/Delete.js